import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-serif text-xl text-[hsl(var(--primary))]">Preparing your memorial space…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-serif text-xl text-[hsl(var(--primary))]">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin' && user.role !== 'platform_admin') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-6">
        <div className="text-center max-w-md" data-testid="admin-route-denied">
          <h1 className="font-serif text-3xl text-[hsl(var(--primary))]">Restricted area</h1>
          <p className="text-[hsl(var(--primary)/0.7)] mt-2">This page is for platform admins only.</p>
        </div>
      </div>
    );
  }
  return children;
}

